import { NextSeo } from 'next-seo';

const TermsAndConditions = () => {
  return (
    <>
      <NextSeo
        title="Terms and Conditions | PrishaPolicy"
        description="Welcome to www.prishapolicy.com (“the Site”) operated by Prisha Insurance Brokers Private Limited(“PrishaPolicy”). PrishaPolicy allows the use of the Site to you subject to the following Terms and Conditions (“Terms”). Kindly, read carefully all the Terms before you may use the Site."
      />
      <div>
        <div className="my-15 container py-12 px-4 text-center">
          <h1 className="heading-6 text-left font-semibold">TERMS & CONDITIONS</h1>
          <p className="mt-6 text-left">
            Welcome to www.prishapolicy.com (“the Site”) operated by Prisha Insurance Brokers Private Limited
            (“PrishaPolicy”). PrishaPolicy allows the use of the Site to you subject to the following Terms and
            Conditions (“Terms”). Kindly, read carefully all the Terms before you may use the Site.
            <br />
            <br />
            The below mentioned terms and conditions shall be effective upon acceptance and if your do not agree to the
            same, you may not use the Site in anyway.
            <br />
            <br />
            This document is an electronic record as per the Information Technology Act, 2000 and rules framed
            thereunder as amended by the Information Technology Act, 2000. This is a computer-generated electronic
            record and does not require any physical or digital signatures.
            <br />
            <br />
            This document is published in accordance with the Rule 3 (1) of the Information Technology (Intermediaries
            guidelines) Rules, 2011 that requires publishing of privacy policy, the rules & regulations & user agreement
            for access or usage of https://www.prishapolicy.com/ (the website)
            <br />
            <br />
            PrishaPolicy reserves the right to change or modify the terms and conditions of use at any time at its sole
            discretion without prior notice and your continued use or access to the Site signifies your acceptance to
            the updated/ modified version of the terms and conditions.
          </p>

          <br />
          <br />
          <h1 className="heading-6 text-left font-semibold">Description of Service</h1>

          <p className="mt-6 text-left">
            PrishaPolicy aims to provide its users/customers with the best policy from the variety of options available,
            which is best suited to their requirements .
          </p>
          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Eligibility</h1>

          <p className="mt-6 text-left">
            The Site is not available for use by minors (i.e., under the age of 18 years) or to any user who does not
            agrees to the terms and conditions or acts contrary to the agreed terms.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Data Storage</h1>

          <p className="mt-6 text-left">
            We may store your data like name, email id, phone number etc, and process the same in accordance with the
            data protection laws of India.
            <br />
            We use your data to do things like provide you our Services , improve and update our Services, troubleshoot
            issues, communicate with you, secure against fraud and abuse, analyse how people use our Services , serve
            personalized advertising, and as required by law or necessary for safety and integrity. We retain your data
            for as long as it is needed to serve the purposes for which it was collected.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Consent</h1>

          <p className="mt-6 text-left">
            By agreeing to the Terms you also, consent to receiving emails, phone calls and SMSs from PrishaPolicy and
            its affiliates regarding their Services and updates.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Limitation of Liability</h1>

          <p className="mt-6 text-left">
            While PrishaPolicy makes reasonable efforts to include accurate and up to date information on this website,
            errors or omissions sometimes occur. In no event including but not limited to acts of negligence arising in
            connection with any information, result, error, defect, delay or system malfunction, shall PrishaPolicy be
            liable for any damages which are direct, incidental, consequential, indirect or punitive.
            <br />
            PrishaPolicy also assumes no responsibility, and shall not be liable for, any damages to, or viruses that
            may infect, your computer equipment or other property as a result of your access to, use of or browsing in
            this website or your downloading of any materials, data, text or images from this website.
            <br />
            To the fullest extent permissible pursuant to Applicable Law, the materials on this website are provided “as
            is” and without warranties of any kind either expressed or implied and Prisha Insurance Brokers Private Limited and its subsidiaries, disclaim all warranties, expressed or implied, including but not limited to,
            implied warranties of merchantability and fitness for a particular purpose.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Link to other Websites</h1>

          <p className="mt-6 text-left">
            This Site may be linked to other websites which are not maintained by PrishaPolicy but are provided for your
            convenience only. PrishaPolicy is not responsible for the content of those websites. The inclusion of any
            link to such websites does not imply approval of or endorsement by Prisha Insurance Brokers Private Limited
            of the websites or the content thereof.
            <br />
            <br />
            PrishaPolicy may integrate with third parties who will interact with you under their terms of service.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Acceptable Use</h1>

          <p className="mt-6 text-left">
            You may use the Site only for lawful purposes and in accordance with these terms and conditions.
            PrishaPolicy may terminate your right to access the Site and may take legal recourse for actual or suspected
            violation of these terms.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Modification and Interruptions</h1>

          <p className="mt-6 text-left">
            PrishaPolicy reserves the right to modify, change or remove the contents or services from the Site from time
            to time to comply with the new laws and regulations or to update their offerings. PrishaPolicy cannot
            guarantee the services will be available at all times. You agree that we have no liability whatsoever for
            any damage or inconvenience caused by your inability to access or use the services during the downtime or
            discontinuance of Services.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Restrictions on Use of Materials</h1>

          <p className="mt-6 text-left">
            This website is owned and operated by PrishaPolicy. Except as otherwise expressly permitted by PrishaPolicy,
            no materials from this website may be copied, reproduced, republished, uploaded, posted, transmitted or
            distributed in any way.
            <br />
            <br />
            PrishaPolicy neither warrants nor represents that your use of materials displayed on this website will not
            infringe rights of third parties not owned by or affiliated with PrishaPolicy.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Indemnification</h1>

          <p className="mt-6 text-left">
            You agree to indemnify, defend, and hold harmless PrishaPolicy from any and all claims, liabilities,
            expenses, and damages (to the extent attributable to you under the applicable law), including reasonable
            attorneys&#39; fees and costs, made by any third party related to: <br />
            <ol className="list-decimal p-[20px]">
              <li> your use or attempted use of the Services in violation of these Terms;</li>
              <li>your violation of any law or rights of any third party;</li>
              <li>
                any claim of infringement or misappropriation of intellectual property or other proprietary rights.
              </li>
            </ol>
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Jurisdictional Issues</h1>

          <p className="mt-6 text-left">
            Unless otherwise expressly set forth herein, Prisha Insurance Brokers Private Limited makes no representation that materials on this website are appropriate or available for use in any location. Those
            who choose to access this website do so on their own initiative and are responsible for compliance with
            local laws.
            <br />
            <br />
            Some products and services may not be available in all jurisdictions. All disputes shall be subject to the
            exclusive jurisdiction of Gurugram Court.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">Customer Support</h1>

          <p className="mt-6 text-left">
            You may reach out to PrishaPolicy to address any queries or complaints to <b>info@prishapolicy.com</b>.
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
